import { Link } from 'react-router-dom';

import { Switch } from '@swivl-mono/ui';
import { Member } from '../../../../Models/Member/Member.Current';
import MembersModel from '../../../../Models/Member/Members.Model';
import "./HeaderAgentView.scss";

export const HeaderAgentView = () => {
  const { isAvailable } = MembersModel.useState(s => s)

  return <div className="HeaderAgentView">
    <Link className="avatar" to="/agent/settings"><img src={Member.avatarURL || "https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/member-avatar-blank.png"} alt="Agent Avatar" /></Link>
    <div className="text">AVAILABLE</div>
    <Switch name="isAvailable" on={isAvailable} onChange={() => { MembersModel.setAvailability(!isAvailable) }} />
  </div>

}